/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from '@/lib/api';

// Albo verification
export const submitAlbo = (payload) => api.post('/security/albo/verify', payload).then(r => r.data);
export const getMyAlbo = () => api.get('/security/albo/me').then(r => r.data);

// 2FA
export const setup2FA = () => api.post('/security/2fa/setup', {}).then(r => r.data);
export const verify2FA = (code) => api.post('/security/2fa/verify', { code }).then(r => r.data);
export const disable2FA = (code) => api.post('/security/2fa/disable', { code }).then(r => r.data);
export const get2FAStatus = () => api.get('/security/2fa/status').then(r => r.data);

// Consents
export const getConsentDefs = () => api.get('/security/consents/defs').then(r => r.data);
export const getMyConsents = () => api.get('/security/consents/me').then(r => r.data);
export const updateConsents = (consents) => api.post('/security/consents', { consents }).then(r => r.data);

// Audit log
export const getMyAudit = (limit = 100) => api.get('/security/audit/mine', { params: { limit } }).then(r => r.data);
